import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const MobiliansResult = () => {
  return <CommonResult />;
};

export default MobiliansResult;
